import * as swcHelpers from '@swc/helpers';
import { getLocalizedString } from '@grandvisionhq/utils';
import { EyeSide } from '../../../../__generated__/sharedTypes.js';
import { toBaseLineItem } from './base-line-item.js';

const isBundledContactLensesLineItem = (bundledLineItem)=>{
    return 'prescription' in bundledLineItem;
};
const isBundledSolutionLineItem = (bundledLineItem)=>{
    return 'volume' in bundledLineItem.product;
};
var toContactLensesBundleOrderLineItem = (orderLineItem, intl, options = {})=>{
    var ref, ref1;
    const base = toBaseLineItem(orderLineItem, intl, options);
    const bundledSolutionLineItem = (ref = orderLineItem.bundledLineItems) === null || ref === void 0 ? void 0 : ref.find(isBundledSolutionLineItem);
    const contactLensesProducts = (ref1 = orderLineItem.bundledLineItems) === null || ref1 === void 0 ? void 0 : ref1.filter(isBundledContactLensesLineItem);
    const leftContactLensesProduct = contactLensesProducts === null || contactLensesProducts === void 0 ? void 0 : contactLensesProducts.find((item)=>item.eyeSide === EyeSide.LEFT || item.eyeSide === EyeSide.BOTH
    );
    const rightContactLensesProduct = contactLensesProducts === null || contactLensesProducts === void 0 ? void 0 : contactLensesProducts.find((item)=>item.eyeSide === EyeSide.RIGHT || item.eyeSide === EyeSide.BOTH
    );
    let prescription = undefined;
    if (rightContactLensesProduct === null || rightContactLensesProduct === void 0 ? void 0 : rightContactLensesProduct.prescription) {
        const _prescription = rightContactLensesProduct.prescription, rightPrescription = swcHelpers.objectWithoutProperties(_prescription, [
            "__typename"
        ]);
        prescription = prescription || {};
        prescription.rightEye = swcHelpers.objectSpread({}, rightPrescription);
    }
    if (leftContactLensesProduct === null || leftContactLensesProduct === void 0 ? void 0 : leftContactLensesProduct.prescription) {
        const _prescription = leftContactLensesProduct.prescription, leftPrescription = swcHelpers.objectWithoutProperties(_prescription, [
            "__typename"
        ]);
        prescription = prescription || {};
        prescription.leftEye = swcHelpers.objectSpread({}, leftPrescription);
    }
    var _totalPaid, _productPrice;
    return swcHelpers.objectSpread({}, base, {
        type: 'CONTACT_LENS_BUNDLE',
        productType: 'contact-lenses-bundle-benelux',
        prescription,
        bundleChildLineItems: bundledSolutionLineItem ? [
            {
                title: intl.getLabel('facets.productType.solutions'),
                body: getLocalizedString(bundledSolutionLineItem.product.name, intl.locale),
                price: (_totalPaid = bundledSolutionLineItem.price.totalPaid) !== null && _totalPaid !== void 0 ? _totalPaid : 0,
                originalPrice: bundledSolutionLineItem.price.productPrice === bundledSolutionLineItem.price.totalPaid ? undefined : (_productPrice = bundledSolutionLineItem.price.productPrice) !== null && _productPrice !== void 0 ? _productPrice : 0
            }, 
        ] : undefined
    });
};

export { toContactLensesBundleOrderLineItem };
//# sourceMappingURL=contact-lenses-bundle-line-item.js.map
